//import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign"
import IimmpactService from "../../service/IimmpactService"

export default function (states) {
    const loadHistory = function () {
        let RedeemKey = states.query.redeemKey
        return new Promise((resolve, reject) => {
            // console.log(states.query.token)
            IimmpactService.apiGetHistory(RedeemKey, states.query.token, states.blobWebLanding).subscribe({
                next: (res) => {
                    states.purchase = res
                    resolve(res)
                },
                error: (err) => {
                    states.purchase = null
                    reject(err)
                }
            });
        })
    }

    return {
        loadHistory
    }
}
